import { render } from "./CommLogForm.vue?vue&type=template&id=38b80c45"
import script from "./CommLogForm.vue?vue&type=script&lang=js"
export * from "./CommLogForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__